// 🤖 AUTO-GENERATED from data/components.json
// DO NOT EDIT MANUALLY - Changes will be overwritten
// Schema version: 1.0.0

import type { VoltraBaseProps } from '../baseProps'

export type LabelProps = VoltraBaseProps & {
  /** Text content for the label */
  title?: string
  /** SF Symbol name for the label icon */
  systemImage?: string
}
